export default __webpack_public_path__ + "static/media/fengshui.bd7dc32c.png";